import { Trash2, Wallet } from "lucide-react";
import { Button } from "@/components/ui/button";
import { money, fmtDate } from "@/lib/format";
import { Confirm, Empty } from "@/components/kit";

// Historial de abonos de una factura con total abonado y saldo
export const PaymentsPanel = ({ doc, onDelete }) => {
  const cur = doc.currency;
  const pct = doc.total ? Math.min(100, (doc.paid_amount / doc.total) * 100) : 0;
  return (
    <div className="panel p-5 mt-6 max-w-[816px] mx-auto" data-testid="payments-panel">
      <div className="flex items-center gap-2 label-cap mb-4"><Wallet className="w-4 h-4 text-[#00F0FF]" />Abonos y saldo</div>
      <div className="grid grid-cols-3 gap-3 text-sm">
        <div><div className="text-slate-400 text-xs">Total</div><div className="mono text-white">{money(doc.total, cur)}</div></div>
        <div><div className="text-slate-400 text-xs">Abonado</div><div className="mono text-emerald-300" data-testid="payments-paid">{money(doc.paid_amount, cur)}</div></div>
        <div><div className="text-slate-400 text-xs">Saldo pendiente</div><div className="mono text-amber-300 font-bold" data-testid="payments-balance">{money(doc.balance, cur)}</div></div>
      </div>
      <div className="h-2 rounded-full bg-[#1A143D] mt-4 overflow-hidden">
        <div className="h-full bg-gradient-to-r from-[#00F0FF] to-[#9D4EDD] transition-[width] duration-500" style={{ width: `${pct}%` }} />
      </div>
      <div className="mt-4" data-testid="payments-list">
        {doc.payments.map((p) => (
          <div key={p.id} className="flex items-center gap-3 py-2.5 border-t border-[#271E56] text-sm" data-testid="payment-row">
            <span className="text-slate-400 w-24">{fmtDate(p.date)}</span>
            <span className="flex-1 min-w-0 truncate text-slate-200">{p.method}{p.note && <span className="text-slate-500"> · {p.note}</span>}</span>
            <span className="mono text-emerald-300">{money(p.amount, cur)}</span>
            {doc.status !== "anulada" && (
              <Confirm title="¿Eliminar este abono?" description="El saldo de la factura aumentará y volverá a quedar pendiente." onConfirm={() => onDelete(p)} actionLabel="Eliminar">
                <Button size="icon" variant="ghost" className="text-rose-400" data-testid="payment-delete-btn"><Trash2 className="w-4 h-4" /></Button>
              </Confirm>
            )}
          </div>
        ))}
        {!doc.payments.length && <Empty text={doc.status === "pagada" ? "Pagada (sin detalle de abonos)" : "Aún no hay abonos registrados"} />}
      </div>
    </div>
  );
};
